"use client";

import { navLinks } from "@/constants/constants";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Navigation = () => {
    const pathname = usePathname();

    return (
        <nav className="z-10 text-xl hidden md:block">
            <ul className="flex gap-10 items-center">
                {navLinks.map(({ href, label, external }) => {
                    const isActive =
                        !external &&
                        (href === "/" || href === "/portfolio"
                            ? pathname === href
                            : pathname.startsWith(href));

                    const className = `text-sm font-medium transition-colors ${
                        isActive
                            ? "text-primary"
                            : "text-foreground hover:text-primary"
                    }`;

                    return (
                        <li key={href}>
                            {external ? (
                                <a
                                    href={href}
                                    aria-label={`Navigate to ${label}`}
                                    className={className}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className="text-primary">@</span> {label}
                                </a>
                            ) : (
                                <Link
                                    href={href}
                                    aria-label={`Navigate to ${label}`}
                                    className={className}
                                >
                                    <span className="text-primary">@</span> {label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Navigation;
